<div class="candidates-container">

    <!-- O ponto que evita mal-entendido: nada aqui esta valendo ainda -->
    <nz-alert nzType="info" nzShowIcon
        [nzMessage]="'agentBuilder.candidates.what'|translateTA"
        [nzDescription]="'agentBuilder.candidates.whatHint'|translateTA">
    </nz-alert>

    <div class="candidates-toolbar">
        <button nz-button nzType="default" (click)="carregar()" [nzLoading]="carregando">
            <nz-icon nzType="reload"></nz-icon>
            {{'agentBuilder.candidates.refresh'|translateTA}}
        </button>

        <span class="candidates-count">
            {{documentos.length}} {{'agentBuilder.candidates.pending'|translateTA}}
        </span>
    </div>

    @if (carregando) {
        <nz-spin nzSimple class="candidates-spin"></nz-spin>
    } @else if (documentos.length === 0) {
        <nz-empty [nzNotFoundContent]="'agentBuilder.candidates.empty'|translateTA"></nz-empty>
    } @else {

        @for (documento of documentos; track documento.correlationId) {

            <div class="candidate-card">

                <div class="candidate-header">
                    <span class="candidate-source">{{documento.source}}</span>
                    <span class="candidate-chunks">
                        {{documento.quantidadeDeChunks}} {{'agentBuilder.candidates.chunks'|translateTA}}
                    </span>
                </div>

                <p class="candidate-preview">{{previa(documento.texto)}}</p>

                <div class="candidate-actions">
                    <button nz-button nzType="primary" nzSize="small" (click)="revisar(documento)">
                        <nz-icon nzType="edit"></nz-icon>
                        {{'agentBuilder.candidates.review'|translateTA}}
                    </button>
                    <button nz-button nzType="default" nzSize="small" nzDanger
                        (click)="confirmarRecusa(documento)">
                        {{'agentBuilder.candidates.reject'|translateTA}}
                    </button>
                </div>

            </div>
        }
    }

</div>


<!-- ============================================================
     Revisao antes de aprovar
     ============================================================ -->
<nz-modal
    [(nzVisible)]="modalAberto"
    [nzTitle]="'agentBuilder.candidates.reviewTitle'|translateTA"
    [nzWidth]="760"
    [nzOkText]="'agentBuilder.candidates.approve'|translateTA"
    [nzOkLoading]="salvando"
    (nzOnCancel)="fecharModal()"
    (nzOnOk)="aprovar()">

    <ng-container *nzModalContent>

        <!-- Editar antes de aprovar e a razao de existir esta tela: o rascunho
             saiu de uma conversa e quase nunca esta pronto para virar fonte -->
        <nz-alert nzType="warning" nzShowIcon class="candidate-warning"
            [nzMessage]="'agentBuilder.candidates.reviewHint'|translateTA">
        </nz-alert>

        <textarea nz-input rows="18" [(ngModel)]="textoRevisado"
            [ngModelOptions]="{standalone: true}"
            class="candidate-editor"></textarea>

    </ng-container>
</nz-modal>
